import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AnnualGrades } from 'src/app/models/app-constants';
import { AnnualGradeIcons } from 'src/app/models/app-constants';

@Component({
  selector: 'app-annual-grade',
  templateUrl: './annual-grade.component.html',
  styleUrls: ['./annual-grade.component.scss']
})
export class AnnualGradeComponent implements OnInit, OnChanges {
  	@Input() annualGrade : string | undefined;
	@Input() description : string = "";
	
	annualGradeIcon : string = "";
	annualGradeText : string = ""
	
	ngOnInit(): void {
		
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(null != changes["annualGrade"]?.currentValue)
		{
			const grade = changes["annualGrade"].currentValue;
			if(!grade)
			{
				this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.NOT_AVAILABLE.description)!;
					this.annualGradeText = AnnualGrades.NOT_AVAILABLE.description;
				return;
			}
			switch(grade?.toString()?.toLowerCase())
			{
				case AnnualGrades.VERY_GOOD.description?.toString()?.toLowerCase() :					
					this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.VERY_GOOD.description)!;
					this.annualGradeText = grade;
					break;
				case AnnualGrades.GOOD.description?.toString()?.toLowerCase() :            
					this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.GOOD.description)!;
					this.annualGradeText = grade;		
					break;
				case AnnualGrades.FAIR.description?.toString()?.toLowerCase() :            
					this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.FAIR.description)!;
					this.annualGradeText = grade;		
					break;
				case AnnualGrades.POOR.description?.toString()?.toLowerCase() :            
					this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.POOR.description)!;
					this.annualGradeText = grade;	
					break;
				case AnnualGrades.VERY_POOR.description?.toString()?.toLowerCase() :            
					this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.VERY_POOR.description)!;
					this.annualGradeText = grade;	
					break;
				case AnnualGrades.FOLLOW_UP.description?.toString()?.toLowerCase() :   
					this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.FOLLOW_UP.description)!;
					this.annualGradeText = AnnualGrades.FOLLOW_UP.description;
					break;
				default : 
					this.annualGradeIcon = AnnualGradeIcons.get(AnnualGrades.NOT_AVAILABLE.description)!;
					this.annualGradeText = AnnualGrades.NOT_AVAILABLE.description;
					break;
			}

		}
	}

}
